// AUTO-GENERATED SQL Builder (V40 Final) for InvoiceRevision
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class InvoiceRevisionSql {
  private ast = new SqlAst('InvoiceRevision', 'invoiceRevision');
  public readonly main: any = {};

  public guid: SqlField;
  public invoiceId: SqlField;
  public revisionNo: SqlField;
  public totalAmount: SqlField;
  public reason: SqlField;
  public issuedDate: SqlField;
  public depositAmount: SqlField;
  public dueAmount: SqlField;
  public protectionFee: SqlField;
  public createdByUser: SqlNavHybrid;
  public invoice: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public invoiceLineList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('invoiceRevision', 'guid', '', 'id', 'invoiceRevision_guid');
    this.invoiceId = new SqlField('invoiceRevision', 'invoiceId', 'invoice', 'id', 'invoiceRevision_invoice');
    this.revisionNo = new SqlField('invoiceRevision', 'revisionNo', '', 'id', 'invoiceRevision_revisionNo');
    this.totalAmount = new SqlField('invoiceRevision', 'totalAmount', '', 'id', 'invoiceRevision_totalAmount');
    this.reason = new SqlField('invoiceRevision', 'reason', '', 'id', 'invoiceRevision_reason');
    this.issuedDate = new SqlField('invoiceRevision', 'issuedDate', '', 'id', 'invoiceRevision_issuedDate');
    this.depositAmount = new SqlField('invoiceRevision', 'depositAmount', '', 'id', 'invoiceRevision_depositAmount');
    this.dueAmount = new SqlField('invoiceRevision', 'dueAmount', '', 'id', 'invoiceRevision_dueAmount');
    this.protectionFee = new SqlField('invoiceRevision', 'protectionFee', '', 'id', 'invoiceRevision_protectionFee');
    this.createdByUser = createNavHybrid('invoiceRevision', 'invoiceRevision_createdByUser', 'User');
    this.invoice = createNavHybrid('invoiceRevision', 'invoiceRevision_invoice', 'Invoice');
    this.updatedByUser = createNavHybrid('invoiceRevision', 'invoiceRevision_updatedByUser', 'User');
    this.invoiceLineList = createNavHybrid('invoiceRevision', 'invoiceRevision_invoiceLineList', 'InvoiceLine');
    this.id = new SqlField('invoiceRevision', 'id', '', 'id', 'invoiceRevision_id');
    this.isDeleted = new SqlField('invoiceRevision', 'isDeleted', '', 'id', 'invoiceRevision_isDeleted');
    this.createdBy = new SqlField('invoiceRevision', 'createdBy', '', 'id', 'invoiceRevision_createdBy');
    this.createdDate = new SqlField('invoiceRevision', 'createdDate', '', 'id', 'invoiceRevision_createdDate');
    this.updatedBy = new SqlField('invoiceRevision', 'updatedBy', '', 'id', 'invoiceRevision_updatedBy');
    this.updatedDate = new SqlField('invoiceRevision', 'updatedDate', '', 'id', 'invoiceRevision_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:InvoiceRevisionSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:InvoiceRevisionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:InvoiceRevisionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:InvoiceRevisionSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:InvoiceRevisionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:InvoiceRevisionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:InvoiceRevisionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:InvoiceRevisionSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:InvoiceRevisionSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:InvoiceRevisionSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
